import { RECEIVE_TOURNAMENT_INFO_PAGE } from '../util/actionTypes';

export const receiveAllPages = (pageList) => ({
  type: RECEIVE_TOURNAMENT_INFO_PAGE,
  pageList: pageList || [],
});
